import { AuthConst } from '@/store/constant/auth.constant'

import type {
    ISigninPayload,
    ISigninAction,
    ISigninSuccessAction,
    ISigninFailAction,
    ISignupAction,
    ISignupSuccessAction,
    ISignupFailAction,
    IAuthAction,
    ISetUserInfoAction,
    IUserInfo,
    IAuth,
    ISetAuthAction,
    IGetAuthAction,
} from '@/store/models/auth.model'

/**
 * 登录
 */
export const signin = (payload: ISigninPayload): ISigninAction => ({
    type: AuthConst.SIGNIN,
    payload
})

export const authsignin = (payload?: string): IAuthAction => ({
    type: AuthConst.AUTHTOKEN,
    payload
})

export const signinSuccess = (message: string): ISigninSuccessAction => ({
    type: AuthConst.SIGNIN_SUCCESS,
    payload: message
})

export const signinFail = (message: string): ISigninFailAction => ({
    type: AuthConst.SIGNIN_FAIL,
    payload: message
})

/**
 * 登出
 */
export const signup = (message: string): ISignupAction => ({
    type: AuthConst.SIGNUP,
    message
})

export const signupSuccess = (message: string): ISignupSuccessAction => ({
    type: AuthConst.SIGNUP_SUCCESS,
    message
})

export const signupFail = (message: string): ISignupFailAction => ({
    type: AuthConst.SIGNUP_FAIL,
    message
})

export const setUserInfo = (payload: IUserInfo | null): ISetUserInfoAction => ({
    type: AuthConst.SETUSERINFO,
    payload
})

export const getAuth = (payload?: { websiteUrl: string }): IGetAuthAction => ({
    type: AuthConst.GETAUTH,
    payload
})
export const setAuth = (payload: IAuth | null): ISetAuthAction => ({
    type: AuthConst.SETAUTH,
    payload
})

export type AuthUnionType =
    | ISigninAction
    | ISigninSuccessAction
    | ISigninFailAction
    | ISignupAction
    | ISignupSuccessAction
    | ISignupFailAction
    | ISetUserInfoAction
    | IGetAuthAction
    | ISetAuthAction
